import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "uk-pagination uk-flex-center impx-pagination uk-margin-remove-top",
  "data-uk-margin": ""
}
const _hoisted_2 = ["onClick"]

import {computed, ref, onMounted, watch} from 'vue';
import Room from "@/models/Room";
import {useStore} from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'CsaPagination',
  props: {
  itemPerpPage:{type:Number, default:10},
},
  emits: ['dataPaginate'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props
const store = useStore()
const page = ref(1);
const totalPage = ref(1);
const dataToPaginate = ref<Room[]>(store.getters['room_data/getRoomFoundData'])
const  setPagination = () =>{
  totalPage.value = Math.ceil(dataToPaginate.value.length / props.itemPerpPage)
  return computed(() =>
      dataToPaginate.value.slice((page.value - 1) * props.itemPerpPage, page.value * props.itemPerpPage)
  );
}
// const setRoomData = ()=>{
//   return computed(()=>store.getters['room_data/getRoomFoundData'])
// }
onMounted(()=>{
  store.dispatch('room_data/loadInitialData')
  emit('dataPaginate', {data:setPagination()??[]})
})
watch(() => store.state.room_data.roomAvailableData, (newValue) => {
  dataToPaginate.value = newValue;
  emit('dataPaginate', {data:setPagination()})
});
const nextPage = () => {
  if (page.value !== Math.ceil(dataToPaginate.value.length / props.itemPerpPage)) {
    page.value += 1;
    emit('dataPaginate', {data:setPagination()})
  }
};
const backPage = () => {
  if (page.value !== 1) {
    page.value -= 1;
    emit('dataPaginate', {data:setPagination()})
  }
};

const goToPage = (numPage:number) => {
  page.value = numPage;
 emit('dataPaginate', {data:setPagination()})

};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: "uk-first-column",
      onClick: backPage
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("a", null, [
        _createElementVNode("span", {
          "data-uk-pagination-previous": "",
          class: "uk-pagination-previous uk-icon"
        }, [
          _createElementVNode("svg", {
            width: "7",
            height: "12",
            viewBox: "0 0 7 12",
            xmlns: "http://www.w3.org/2000/svg",
            "data-svg": "pagination-previous"
          }, [
            _createElementVNode("polyline", {
              fill: "none",
              stroke: "#000",
              "stroke-width": "1.2",
              points: "6 1 1 6 6 11"
            })
          ])
        ])
      ], -1)
    ]))]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPage.value, (p) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass(p==page.value?'uk-active':''),
        key: p,
        onClick: ($event: any) => (goToPage(p))
      }, [
        _createElementVNode("span", null, _toDisplayString(p), 1)
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("li", { onClick: nextPage }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("a", null, [
        _createElementVNode("span", {
          "data-uk-pagination-next": "",
          class: "uk-pagination-next uk-icon"
        }, [
          _createElementVNode("svg", {
            width: "7",
            height: "12",
            viewBox: "0 0 7 12",
            xmlns: "http://www.w3.org/2000/svg",
            "data-svg": "pagination-next"
          }, [
            _createElementVNode("polyline", {
              fill: "none",
              stroke: "#000",
              "stroke-width": "1.2",
              points: "1 1 6 6 1 11"
            })
          ])
        ])
      ], -1)
    ]))])
  ]))
}
}

})